import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalOutlined } from '@ant-design/icons';
import { Image, Select, message } from 'src/design-system/components/atoms';
import { LANGUAGE_OPTIONS } from 'src/utils/constants';
import { OrgTrackConfig } from '../GlobalTrack.types';
import { useTrackHeaderStyles } from '../GlobalTrack.styles';

interface IProps {
  orgConfig: OrgTrackConfig;
}

const LANGUAGE_SELECT_OPTIONS = LANGUAGE_OPTIONS.map((option) => ({
  label: option.val,
  value: option.key,
}));

const TrackHeader = (props: IProps) => {
  const { orgConfig } = props;
  const { i18n } = useTranslation();
  const classes = useTrackHeaderStyles();

  const showLogo = !orgConfig.hideLogo && Boolean(orgConfig.logoUrl);

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value, (err) => {
      if (err) {
        message.error(String(err));
        return;
      }
      window.location.reload();
    });
  };

  return (
    <div className={classes.header}>
      <div className={classes.logoWrap}>
        {showLogo ? (
          <Image
            src={orgConfig.logoUrl}
            alt={orgConfig.organisationName || ''}
            preview={false}
            className={classes.logo}
          />
        ) : null}
      </div>
      <Select
        className={classes.languageSelect}
        value={i18n.language}
        onChange={(value) => handleLanguageChange(value as string)}
        suffixIcon={<GlobalOutlined />}
        options={LANGUAGE_SELECT_OPTIONS}
      />
    </div>
  );
};

export default TrackHeader;
